import React, { useState } from "react"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import questionIcon from "images/question.svg"
import { Checkbox, Popover } from "antd"
import { flatMap } from "lodash"

const ModalInvite = (props) => {
  const [loading, setLoading] = useState(false)
  const [invitate, setInvitate] = useState(true)

  const save = async () => {
    setLoading(true)
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: "employees/teamleader/user",
        data: {
          send_invitation: invitate,
          employees: flatMap(props.usersSelected, (item) => {
            return { id_employee: item.id_employee }
          }),
        },
      })
      setLoading(false)
      returnMessage(result)
      props.onFinish(true)
      setInvitate(true)
    } catch (error) {
      returnMessage(error)
    }
    setLoading(false)
  }

  const header = () => {
    const userSelecteds = props.usersSelected

    if (userSelecteds.length === 1) {
      return (
        <b className="component-deletesimple__title">
          ¿Estás seguro de que deseas activar como usuario al <br /> líder{" "}
          {userSelecteds[0].first_name} {userSelecteds[0].last_name}?
        </b>
      )
    }
    return (
      <div>
        <b className="component-deletesimple__title">
          ¿Estás seguro de que deseas activar como usuarios a <br /> los líderes
          seleccionados?
        </b>

        <span
          style={{
            display: "block",
            marginTop: 12,
            fontSize: 12,
            fontWeight: "normal",
          }}
          className="color-gray-low">
          Líderes a activar: <b>{userSelecteds.length}</b>
        </span>
      </div>
    )
  }

  return (
    <ModalCustom
      onCancel={() => {
        props.onCancel()
        setInvitate(true)
      }}
      onOk={save}
      modalOpen={props.open}
      showFooter
      isLoadingButton={loading}>
      <div className="component-deletesimple">
        <img src={alertSvg} className="alertIcon" />
        <div className="component-deletesimple__description">
          {header()}

          <p style={{ marginTop: 12 }}>
            Esta acción le
            {props.usersSelected.length > 1 && "s"} dará <b>acceso</b> a la
            plataforma y le
            {props.usersSelected.length > 1 && "s"} permitirá visualizar
            <br /> sus <b>resultados</b> de liderazgo una vez habilitados.
          </p>
        </div>
      </div>

      <div style={{ textAlign: "left", marginTop: 15, display: "flex" }}>
        <Checkbox
          checked={invitate}
          onChange={(e) => setInvitate(e.target.checked)}>
          Enviar correo de invitación al sistema.
        </Checkbox>
        <Popover
          placement="top"
          content={
            <div>
              Los líderes recibirán un{" "}
              <b>
                correo de <br /> invitación
              </b>{" "}
              al sistema al ser asignados
            </div>
          }>
          <img src={questionIcon} alt="question-icon" />
        </Popover>
      </div>
    </ModalCustom>
  )
}

ModalInvite.defaultProps = { onCancel: () => {} }

export default ModalInvite
